import React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";


const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};
const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const Badge = ({ text, color }) => (
  <span
    style={{
      background: `rgba(${color},0.15)`,
      color: `rgb(${color})`,
      fontSize: "11px",
      padding: "4px 10px",
      borderRadius: "999px",
      fontWeight: "600",
    }}
  >
    {text}
  </span>
);

const AttackIndicators = () => {
  return (

    <Card style={{ ...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      <CardHeader className=" bg-light d-flex align-items-center">
        <h5 className="card-title mb-0">
          <div style={pageIconWrapStyle} className="me-2">
            <i className="ri-alert-line" style={pageIconStyle} ></i>
          </div>

          ATTACK INDICATORS (CTI)
        </h5>
      </CardHeader>

      <CardBody>

        <div className="d-flex justify-content-between mb-3">
          <span>Stuxnet-Style Activity</span>
          <Badge text="NEGATIVE" color="250,204,21" />
        </div>

        <div className="d-flex justify-content-between mb-3">
          <span>Triton-Like Safety Manipulation</span>
          <Badge text="DETECTED" color="239,68,68" />
        </div>

        <div className="d-flex justify-content-between mb-3">
          <span>Industroyer Grid Injection</span>
          <Badge text="NEGATIVE" color="250,204,21" />
        </div>

        <div className="d-flex justify-content-between">
          <span>ICS Reconnaissance</span>
          <Badge text="ACTIVE" color="34,197,94" />
        </div>

      </CardBody>
    </Card>

  );
};

export default AttackIndicators;